import React, { Component, createRef } from "react";
// // Editable
// import { BootstrapTable,TableHeaderColumn } from "react-bootstrap-table";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import validate from "../../common/validation";

import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { categoriTypes } from "../StaticData.js";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addDataEntryStock,
  getUserByRoleId,
  updateDataEntryStock,
  updateFillerStock,
  updateStockInward
} from "../../api";
import { withTranslation } from "react-i18next";

class DataEntryAddStockOutward extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      deliveryBoyList: [],
      props: props?.location?.query
        ? props.location.query
        : {
            isEdit: false,
            isEditDataEntry: false,
            isPending: false,
            isView: false,
            data: null,
          },
      graderList: [],
      notEditableRows: props?.location?.query.data.stockFillerInWards.map(
        x => x.id
      ),
      stockList: props?.location?.query.data.stockFillerInWards,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    const grader = await getUserByRoleId("ROLE0000002");
    const deliveryBoy = await getUserByRoleId("ROLE0000006");
    if(grader && grader.data){
      this.setState({
        graderList: grader.data.users,
      });
    }
    if(deliveryBoy && deliveryBoy.data){
      this.setState({
        deliveryBoyList: deliveryBoy.data.users,
      });
    }
    
    
  }
  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }
  addRow() {
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          categoryId: 1,
          weight: 0,
          weightType: "CT",
          pieces: 0,
          selfInternalRemarks: "",
          forNextPersonRemarks: "",
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
  }
  handleSubmit = async (e, values) => {
    // if (this.state.stockList.filter(x => x.weight > 0 && x.pieces > 0).length) {
      if (this.state.props.isEdit == 1) {
        let temp = {};
        temp.jangadId = values.id;
        temp.remarks = values.dataEntryPersonRemarks;
        temp.graderUserId = values.graderUserId;
        temp.stockDataEntryInWards = this.state.stockList.filter(
          x => x.weight > 0 && x.pieces > 0
        );
        e.preventDefault();
        const data = await addDataEntryStock(temp);
      } else {
        let temp = {};
        temp.id = values.id;
        // temp.jangadId = values.jangadId;
        // temp.graderUserId = values.graderUserId;
        temp.toDeliverBoyId = values.toDeliverBoyId;
        // temp.stockDataEntryInWards = this.state.stockList.filter(
        //   x => x.weight > 0 && x.pieces > 0
        // );
        e.preventDefault();
        const data = await updateStockInward(temp);
        const fillerstock = await updateFillerStock(
          {id:this.state.props.data.id,salesOfficeAcceptStatus: "P"}
        );
      }
    // }
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "data entry person";
    //meta title
    this.columns1 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: "",
      },
      {
        dataField: "categoryId",
        text: "Categories",
        footer: "",
        editor: {
          type: Type.SELECT,
          options: categoriTypes,
        },
        formatter: (cell, row) => {
          return categoriTypes.filter(x => x.value == cell)[0].label;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "pieces", newValue, row, column),
      },
      {
        dataField: "selfInternalRemarks",
        text: `${this.props.t('Self Internal Remarks')}`,
        footer: "",
      },
      {
        dataField: "forNextPersonRemarks",
        text: `${this.props.t('For Next Person Instruction')}`,
        footer: "",
      },
      // {
      //   dataField: "edit",
      //   text: `${this.props.t('Edit Data')}`,
      //   footer: "",
      //   editable: true,

      //   editorRenderer: (
      //     editorProps,
      //     value,
      //     row,
      //     column,
      //     rowIndex,
      //     columnIndex
      //   ) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows: [...this.state.notEditableRows, row.id],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               if (
      //                 this.state.notEditableRows.length ===
      //                 this.state.stockList.length
      //               )
      //                 this.setState({
      //                   notEditableRows: this.state.notEditableRows.filter(
      //                     x => x != row.id
      //                   ),
      //                 });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //         <button
      //           className="bg-transparent border-0 ms-3"
      //           onClick={() => this.deleteRow(rowIndex)}
      //         >
      //           <img src="images/dashboard-images/deleteRow.svg"></img>
      //         </button>
      //       </div>
      //     );
      //   },
      //   formatter: (cell, row, rowIndex) => (
      //     <div className="btn-group">
      //       {!this.state.notEditableRows.includes(row.id) ? (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             this.setState({
      //               notEditableRows: [...this.state.notEditableRows, row.id],
      //             });
      //           }}
      //         >
      //           <img src="images/dashboard-images/print.svg"></img>
      //         </span>
      //       ) : (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             if (
      //               this.state.notEditableRows.length ===
      //               this.state.stockList.length
      //             )
      //               this.setState({
      //                 notEditableRows: this.state.notEditableRows.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //           }}
      //         >
      //           <img src="images/dashboard-images/edit.svg"></img>
      //         </span>
      //       )}
      //       <button
      //         className="bg-transparent border-0 ms-3"
      //         onClick={() => this.deleteRow(rowIndex)}
      //       >
      //         <img src="images/dashboard-images/deleteRow.svg"></img>
      //       </button>
      //     </div>
      //   ),
      // },
    ];

    this.columns2 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categoryId",
        text: "categoryId",
        formatter: (cell, row) => {
          return categoriTypes.filter(x => x.value == cell)[0].label;
        },
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "selfInternalRemarks",
        text: `${this.props.t('Self Internal Remarks')}`,
        footer: "",
      },
      {
        dataField: "forNextPersonRemarks",
        text: `${this.props.t('For Next Person Instruction')}`,
        footer: "",
      },
    ];
    document.title = "data-entry flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={`${this.props.t("MANAGE STOCK - INWARD")}`} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={
                  {
                    id: this.state.props.data.stock.id,
                    // partyName: this.state.props.data.stock.party.name,
                    unitName: this.state.props.data.stock.factory.name,
                    weight: this.state.props.data.stock.weight,
                    pieces: this.state.props.data.stock.pieces,
                    graderUserId: this.state.props.data.graderStock.user.id,
                    dataEntryPersonRemarks:
                      this.state.props.data.stock.dataEntryPersonRemarks,
                    graderRemarks: this.state.props.data.graderRemarks,
                    toDeliverBoyId: this.state.props.data.stock.toDeliverBoyId || ""
                  }
                }
                validationSchema={Yup.object().shape({
                  id: Yup.string().required("This value is required"),
                  // partyName: Yup.string().required("This value is required"),
                  unitName: Yup.string().required("This value is required"),
                  weight: Yup.string().required("This value is required"),
                  pieces: Yup.string().required("This value is required"),
                  graderUserId: Yup.string().required("This value is required"),
                  dataEntryPersonremarks: Yup.string().max(512).nullable().notRequired(),
                  graderremarks: Yup.string().max(512).nullable().notRequired(),
                  toDeliverBoyId: Yup.string().required(),
                })}
                onSubmit={values => {}}
              >
                {({ errors, status, touched, values, submitCount }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            {this.state.props.isEdit == 1 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("Add New Stock (Inward)")}
                              </h4>
                            )}
                            {this.state.props.isEdit == 2 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t('Edit Stock (Inward)')}
                              </h4>
                            )}
                            {this.state.props.isEdit == 3 && (
                              <h4 className="text-black fw-bold mb-4">
                                View Stock (Inward)
                              </h4>
                            )}
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="id"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t('Stock ID')}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.id && touched.id
                                        ? " is-invalid"
                                        : "")
                                    }
                                    readOnly
                                    type="text"
                                    name="id"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="id"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              {/* <div className="mb-3 row">
                                <Label
                                  htmlFor="partyName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t('Party Name')}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyName && touched.partyName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    readOnly
                                    type="text"
                                    name="partyName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="partyName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div> */}
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="unitName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">{this.props.t("Unit Name")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.unitName && touched.unitName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    readOnly
                                    type="text"
                                    name="unitName"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="unitName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="weight"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">{this.props.t("Total Weight")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.weight && touched.weight
                                        ? " is-invalid"
                                        : "")
                                    }
                                    readOnly
                                    type="number" onWheel={(e) => e.target.blur()}
                                    name="weight"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="weight"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="pieces"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t('Total No of Pieces')}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.pieces && touched.pieces
                                        ? " is-invalid"
                                        : "")
                                    }
                                    readOnly
                                    type="number" onWheel={(e) => e.target.blur()}
                                    name="pieces"
                                    placeholder="2001"
                                  />
                                  <ErrorMessage
                                    name="pieces"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="graderUserId"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Grader Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control form-select fs-5" +
                                      (errors.graderUserId &&
                                      touched.graderUserId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={true}
                                    name="graderUserId"
                                    as="select"
                                  >
                                    <option value="" disabled>select</option>
                                    {this.state.graderList?.map(x => (
                                      <option key={x.id} value={x.id}>
                                        {x.name}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage
                                    name="graderUserId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="toDeliverBoyId"
                                  className="col-lg-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t('Delivery Boy Name')}
                                  </h5>
                                </Label>
                                <div className="col-lg-7 col-12">
                                  <Field
                                    className={
                                      "form-control form-select fs-5" +
                                      (errors.toDeliverBoyId &&
                                      touched.toDeliverBoyId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name="toDeliverBoyId"
                                    as="select"
                                    disabled={
                                      this.state.props.isEdit == 3
                                        ? true
                                        : false
                                    }
                                  >
                                    <option value="" disabled>
                                      select
                                    </option>
                                    {this.state.deliveryBoyList?.map(x => (
                                      <option key={x.id} value={x.id}>
                                        {x.name}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage
                                    name="toDeliverBoyId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                      </div>

                      {/* {this.state.props.isEdit == 3 ? (
                        ""
                      ) : (
                        <div className="row px-3 pt-3">
                          <div className="d-flex justify-content-between">
                            <h3 className="fw-bold pb-3 text-black">
                              {this.props.t('Enter stock Details')}
                            </h3>
                          </div>
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              classes="foo"
                              headerClasses="background-light fs-5"
                              footerClasses="background-light fs-5"
                              data={this.state.stockList}
                              columns={this.columns1}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                nonEditableRows: () =>
                                  this.state.notEditableRows,
                              })}
                            />
                            {submitCount > 0 &&
                            this.state.stockList.filter(
                              x => x.weight > 0 && x.pieces > 0
                            ).length != this.state.stockList.length ? (
                              <p className="text-danger">
                                Enter minimum one record
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )} */}

                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t('Stock summary')}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.state.stockList}
                            columns={this.columns2}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="stockDataEntryInWards"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("Self Internal Remarks")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.dataEntryPersonRemarks &&
                              touched.dataEntryPersonRemarks
                                ? " is-invalid"
                                : "")
                            }
                            readOnly={true}
                            type="text"
                            name="dataEntryPersonRemarks"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="dataEntryPersonRemarks"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="graderRemarks"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t('For Next Person Remarks')}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.graderRemarks && touched.graderRemarks
                                ? " is-invalid"
                                : "")
                            }
                            disabled={true}
                            type="text"
                            name="graderRemarks"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="graderRemarks"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      {this.state.props.isEdit == 3 ? (
                        <div className="col-md-12 text-center text-md-end pe-3 py-5">
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => this.state.history.goBack()}
                          >
                            Back
                          </Button>
                        </div>
                      ) : (
                        <div className="col-md-12 text-center text-md-end pe-3 py-5">
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => this.handleSubmit(event, values)}
                          >
                            Submit And OutWard
                          </Button>
                        </div>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}


export default withTranslation()(DataEntryAddStockOutward);
